import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
    const { logout, limitAccess } = useAuth();
    const navigate = useNavigate();
    
    return (        
        <nav className="navbar">
            <div className="navbar-brand">
                PCP Sign Up Portal
            </div>
            <div className="navbar-right">
                <ul>
                    <li onClick={() => navigate('/push-email')}>Resend Email</li>  
                    <li onClick={logout}>Logout</li>
                    
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;